import styled from 'styled-components';

export const Styled = styled.span`
    display: flex;
    align-items: center;
    width: 100%;

    .span__label-icon-group {
        flex: 0 1 auto;
    }

    .new-tab-icon {
        margin-top: 1px;
        font-size: 18px;
    }
`;
